import { forwardRef } from "react";
import Tooltip from "../../tooltip/Tooltip";
import "./_checkbox.scss";

/**
 * Pure-UI checkbox. `value` is the checked boolean (not `checked` - matches
 * every other input's `value` prop in this codebase, a smaller diff to wire
 * into a form engine's generic field mapping). `onChange` receives the raw
 * boolean, not the DOM event. No validation logic here - that's the
 * caller's job (e.g. react-hook-form).
 */
const Checkbox = forwardRef(function Checkbox(
  {
    id,
    label,
    description,
    value = false,
    onChange,
    onBlur,
    error,
    disabled = false,
    tooltip,
    className = "",
    ...rest
  },
  ref
) {
  return (
    <Tooltip content={tooltip} disabled={!tooltip} className="checkbox-tooltip-anchor">
      <div
        className={`checkbox ${error ? "checkbox--error" : ""} ${
          disabled ? "checkbox--disabled" : ""
        } ${className}`}
      >
        <label className="checkbox__row" htmlFor={id}>
          <input
            ref={ref}
            id={id}
            type="checkbox"
            className="checkbox__input"
            checked={Boolean(value)}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.checked)}
            onBlur={onBlur}
            {...rest}
          />
          <span className="checkbox__box" aria-hidden="true" />
          {label && <span className="checkbox__label">{label}</span>}
        </label>
        {description && <p className="checkbox__description">{description}</p>}
        {error && <p className="checkbox__error">{error}</p>}
      </div>
    </Tooltip>
  );
});

export default Checkbox;
